import { axios } from "../http-common";

class Account {
  listPayee() {
    return axios.get("v1/member/accounts/show-payee");
  }
  transfer(data) {
    return axios.post("v1/member/accounts/transfer", data);
  }
  transferDetail(data) {
    return axios.post("v1/member/accounts/transfer-detail", data);
  }
  getBalance(data) {
    return axios.post("v1/member/accounts/check-balance-account", data);
  }
  transferList(data) {
    return axios.get("v1/member/accounts/get-transfer-byuserno", {
      params: data,
    });
  }
  depositList() {
    return axios.get("v1/member/accounts/get-account-topup");
  }

  updateInternational(data) {
    return axios.post("v1/member/update-account/update-international", data);
  }
  updateHongkong(data) {
    return axios.post("v1/member/update-account/update-hongkong", data);
  }
  updateChina(data) {
    return axios.post("v1/member/update-account/update-domestic", data);
  }
  updateIndividual(data){
    return axios.post("v1/member/update-account/update-domestic-individual", data);
  }
}

export default new Account();
